import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-lg container-fluid my_files" }
const _hoisted_2 = { class: "my-4" }
const _hoisted_3 = { class: "card card-body border-0 shadow" }
const _hoisted_4 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_5 = { class: "p-input-icon-left" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_7 = { class: "p-text-center" }
const _hoisted_8 = { class: "p-text-center" }
const _hoisted_9 = ["href", "id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SubBar = _resolveComponent("SubBar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SubBar),
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_component_DataTable, {
        responsiveLayout: "scroll",
        breakpoint: "700px",
        selection: _ctx.dataSelected,
        "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataSelected) = $event)),
        dataKey: "id",
        value: _ctx.getRelevantDocument,
        paginator: true,
        loading: _ctx.loading,
        rows: 10,
        selectionMode: "single",
        columnResizeMode: "fit",
        scrollHeight: "flex",
        globalFilterFields: ['innovation'],
        filters: _ctx.filters,
        "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
        filterDisplay: "menu",
        class: "p-datatable-sm",
        "row-hover": true
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-plus",
              label: "New",
              class: "p-button-primary p-button-sm d-none"
            }),
            _createVNode(_component_Badge, { severity: "warning" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.dataSelected.length !== 0 ? _ctx.dataSelected.length : "No") + " File(s) selected", 1)
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_InputText, {
                modelValue: _ctx.filters['global'].value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
                placeholder: " Search files ",
                class: "p-inputtext-sm"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createElementVNode("h6", _hoisted_7, "No " + _toDisplayString(_ctx.title) + " found!.", 1)
        ]),
        loading: _withCtx(() => [
          _createElementVNode("h6", _hoisted_8, "Loading " + _toDisplayString(_ctx.title) + " data. Please wait.", 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            selectionMode: "multiple",
            headerStyle: "width: 3em"
          }),
          _createVNode(_component_Column, {
            field: "name",
            header: "Name",
            sortable: true,
            style: {"min-width":"25rem"},
            frozen: true
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("a", {
                target: "_blank",
                rel: "noopener noreferrer",
                href: slotProps?.data?.name,
                id: slotProps.data.id
              }, _toDisplayString(_ctx.getFileName(slotProps?.data?.name)), 9, _hoisted_9)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "",
            header: "Date Created",
            sortable: true,
            style: {"min-width":"15rem"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.getDateTime(slotProps?.data?.date)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            style: {"min-width":"10rem"},
            field: "size",
            header: "File size"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps?.data?.size) + " KB ", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            style: {"min-width":"15rem"},
            field: "type",
            header: "Type"
          })
        ]),
        _: 1
      }, 8, ["selection", "value", "loading", "filters"])
    ])
  ]))
}